import SMAppHomeBanner from '../../containers/App-Home/Banner'
import SMAppHomeFinancingWithUs from '../../containers/App-Home/WithUs'
import SMAppHomeSteps from '../../containers/App-Home/ProductStep'
import SMAppHomeWhyApply from '../../containers/App-Home/WhyApply'
import SMAppHomeDownload from '../../containers/App-Home/DownLoad'
import SMAppHomeFindIdeal from '../../containers/App-Home/FindIdeal'
import SMAppHomeWhatsNew from '../../containers/App-Home/WhatsNew'
import SMAppHomeContactUs from '../../containers/App-Home/ContactUs'
import SMHomeWhatsNew from '../../containers/Home/WhatsNew'
import { ScreenWidthPort } from '../../ScreenWidthContext'

export const AppHomeScreen: React.FC = () => {
    const { showDesktopUI } = ScreenWidthPort()

  // ======================= VIEWS
  return (
    <>
      <SMAppHomeBanner />
      <SMAppHomeFinancingWithUs />
      <SMAppHomeSteps />
      <SMAppHomeWhyApply />
      <SMAppHomeDownload />
      <SMAppHomeFindIdeal />
      {showDesktopUI ? (<SMHomeWhatsNew />) : (<SMAppHomeWhatsNew />)}
      <SMAppHomeContactUs />
    </>
  )
}

// ======================= EXPORT
export default AppHomeScreen
